// Kur & Yakıt ayarlarının tri-state görünürlüğü.
// Sektör varsayılanı: market ailesinde AÇIK, diğer sektörlerde GİZLİ.
// Big BOSS Platform panelinden kiracı bazında "Zorla Aç / Zorla Kapat" ile override edebilir (upsell).
export const MARKET_FAMILY = ["market", "depo", "toptan", "magaza", "eticaret", "gida"];

// Aktif sektör market ailesinde mi? Boş / "full" / "__all__" (Tüm Sektörler → owner) da AÇIK sayılır.
export const isMarketFamilySector = (sec) =>
  !sec || sec === "full" || sec === "__all__" || MARKET_FAMILY.includes(sec);

// Aktif sektörün kanal etiketleri (market/toptan) — sektör tanımlıysa onları, değilse varsayılanı döndürür.
// Tüm sayfalar "Market/Toptan" yerine sektöre özel etiketi (Reçete/OTC, Depo, Menü, Vitrin...) göstersin.
export const channelLabels = (sectorObj) => ({
  market: sectorObj?.channel_labels?.market || "Market",
  toptan: sectorObj?.channel_labels?.toptan || "Toptan",
});

// Platform panelinde yönetilen tri-state görünürlük bayrakları.
export const VISIBILITY_FLAGS = [
  { key: "module.market_pricing", label: "Kur & Piyasa Fiyat İzleme (Döviz)" },
  { key: "module.fuel_pricing", label: "Akaryakıt Fiyat İzleme" },
  { key: "cap.market_research", label: "Piyasa Fiyatı Araştırması (Rakip Fiyat / Fırsatlar)" },
];
